export const More = (props) => {
  const { size = 20, onClick, verticalAlign, marginLeft, marginRight, top, color, className = '' } = props;
  return (
    <span onClick={onClick} className={`icon-wrap ${className}`} style={{ marginLeft, marginRight, top, color }}>
      <svg style={{ verticalAlign }} width={size} height={size} xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'>
        <path
          fill='currentColor'
          d='M10 10.833a.833.833 0 100-1.666.833.833 0 000 1.666zM15.833 10.833a.833.833 0 100-1.666.833.833 0 000 1.666zM4.167 10.833a.833.833 0 100-1.666.833.833 0 000 1.666z'
        ></path>
        <path
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='1.5'
          d='M10 10.833a.833.833 0 100-1.666.833.833 0 000 1.666zM15.833 10.833a.833.833 0 100-1.666.833.833 0 000 1.666zM4.167 10.833a.833.833 0 100-1.666.833.833 0 000 1.666z'
        ></path>
      </svg>
    </span>
  );
};
